import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-layout',
  templateUrl: './signup-layout.component.html',
  styleUrls: ['./signup-layout.component.scss']
})
export class SignupLayoutComponent implements OnInit {
  currentStep:any;
  constructor() { }

  ngOnInit(): void {
  }

}
